import { Request } from "@tools/base";;
const { Axios } = Request;

const URL = "/v1/equity/account/";

//获取收藏列表
export function get_symbolStar(config?) {
  return Axios.get(URL + `symbol-star/list`, config);
}

//加入收藏列表
export function post_symbolStar(config?) {
  return Axios.post(URL + `symbol-star/add`, null, config);
}

//取消收藏列表
export function delete_symbolStarId(id, config?) {
  return Axios.delete(URL + `symbol-star/cancel/${id}`, config);
}

//股票划转验证
export function equity_valid() {
  return Axios.post(URL + `user/valid`);
}

//获取用户身份，跟单员或带单员
export function get_copyTradeUserStatus(config?) {
  // return new Promise((resolve) => resolve("FOLLOWER"));
  return Axios.get(URL + `copy-trade/user-status`, config);
}

//获取用户手续费抵扣配置
export function get_tradeDeductionFee(config?) {
  return Axios.get(URL + `trade-deduction/fee`, config);
}

//设置用户手续费抵扣配置
export function post_tradeDeductionFee(config?) {
  return Axios.post(URL + `trade-deduction/fee`, null, config);
}

//获取下单手续费配置
export function get_tradeFee(config) {
  return Axios.post(URL + `trade/fee`, config);
}

// 股票开户前置验证
export function checkoutAccount(config?) {
  return Axios.post(URL + `user/checkOpenAccount`, config);
}


